import React from 'react'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import dayjs from 'dayjs'
import { Button, Checkbox, Form, Input } from 'antd'
import { Trans, useLingui } from '@lingui/react/macro'

import { btnCls, formCls } from '../../classes'
import LabelItem from '../../../LabelItem'
import UserEntryFormContainer from '../../../UserEntryFormContainer'

import type { ISignUpFormValues, ISignUpStepProps } from '..'

import { usePwdRules } from '@/contexts/AuthContext/hooks/pwdRules'
import { CssIcon } from '@/components/CssIcon'


import { cls, tw } from 'tagged-classnames-free';
import Link from '@/components/Link';
dayjs.extend(utc)
dayjs.extend(timezone)

export interface IStep2Props extends ISignUpStepProps {
  className?: string
}

const Step2: React.FC<IStep2Props> = (props) => {
  const { loading, titleAs, formContainerClassName, handleCreate } = props
  const { t } = useLingui()

  const onNext = () => {
    handleCreate()
  }

  const pwdRules = usePwdRules()

  return (
    <UserEntryFormContainer
      className={formContainerClassName}
      titleAs={titleAs}
      title={<Trans>Create your account</Trans>}
      titleClassName='mb-1'
      descClassName={formCls}
      description={
        <Trans>Enter your name and a password for your new account.</Trans>
      }
      iconClassName='hidden'
    >
      <div className={formCls}>
        <Form.Item
          style={{
            marginBottom: 0,
          }}
        >
          <Form.Item
            className={cls`
              inline-block w-[calc(50%-6px)]
            `}
            name='firstName'
            rules={[
              { required: true, message: t`Please input your first Name.` },
            ]}
            label={
              <LabelItem>
                <Trans>First Name</Trans>
              </LabelItem>
            }
          >
            <Input className='h-12' placeholder={t`First Name`} />
          </Form.Item>
          <Form.Item
            className={cls`
              inline-block w-[calc(50%-6px)]
            `}
            style={{
              marginLeft: 12,
            }}
            name='lastName'
            rules={[
              { required: true, message: t`Please input your last Name.` },
            ]}
            label={
              <LabelItem>
                <Trans>Last Name</Trans>
              </LabelItem>
            }
          >
            <Input
              className='h-12'
              autoComplete='off'
              placeholder={t`Last Name`}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          name='password'
          rules={pwdRules}
          required={false}
          label={
            <LabelItem>
              <Trans>Password</Trans>
            </LabelItem>
          }
        >
          <Input.Password
            className='h-12'
            maxLength={16}
            autoComplete='new-password'
            placeholder={t`Password`}
          />
        </Form.Item>
        <Form.Item
          name='accepted'
          valuePropName='checked'
          // noStyle
          rules={[
            () => ({
              validator(rule, value) {
                if (value === true) {
                  return Promise.resolve()
                }
                return Promise.reject(
                  new Error(t`Please accept the Terms and Conditions`),
                )
              },
            }),
          ]}
        >
          <Checkbox className='w-full text-left [&_.coco-checkbox-inner]:border-2'>
            <span className='text-f-text-secondary text-sm'>
              <Trans>
                I accept the{' '}
                <Link
                  target='_blank'
                  href='/terms'
                  rel='nofollow noreferrer'
                  className='text-f-primary hover:text-f-primary-hover'
                >
                  Terms of Use
                </Link>
              </Trans>
            </span>
          </Checkbox>
        </Form.Item>
        <Form.Item<ISignUpFormValues> noStyle shouldUpdate>
          <Button
            type='primary'
            block
            className={tw`
              ${btnCls}
            `}
            loading={loading}
            onClick={onNext}
          >
            <span>
              <Trans>Create account</Trans>
            </span>
            <CssIcon
              className={cls`
                i-com--right-arrow size-6 transition-transform group-hover:translate-x-1
              `}
            />
          </Button>
        </Form.Item>
      </div>
    </UserEntryFormContainer>
  )
}

export default Step2
